import React from "react";
import { useLocation } from "react-router-dom";
import Product from "../Components/Product";
import { usePageTitle } from "../Utilities/usePageTitle";

const AiResults = () => {
    const { state } = useLocation();
    const products = state?.products || [];
    const query = state?.query || "";
    usePageTitle(query ? `AI: ${query}` : 'חיפוש AI');

    return (
        <div className="container py-4">
            <h4>תוצאות עבור: "{query}"</h4>
            <div className="d-flex flex-wrap justify-content-between mb-2">
                <p className="text-muted">{products.length} מוצרים נמצאו</p>
            </div>
            <hr />
            {products.length === 0 ? (
                <div className="text-center pt-5">
                    <h3>לא נמצאו מוצרים</h3>
                </div>
            ) : (
                <div className="d-flex flex-wrap justify-content-around">
                    {products.map((product) => (
                        <Product product={product} key={product.id} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default AiResults;
